import { useQuery } from '@tanstack/react-query';

import { useDebouncedValue } from '@shared/hooks';
import { ordersRecognitionApi } from '@widgets/OrdersRecognition/api';
import { useOrdersRecognitionContext } from '@widgets/OrdersRecognition/lib/hooks/useOrdersRecognitionContext';

// export const useSearchOrders = () => {
//     const { state } = useNuqsQueryState(ORDERS_SEARCH_QUERY);
//
//     return useQuery({
//         ...ordersRecognitionApi.getOrdersRecognitionSearchQueryOptions({ queryString: state }),
//     });
// };

/// //////
// export const useSearchOrders = () => {
//     // const { state } = useNuqsQueryState(ORDERS_SEARCH_QUERY);
//     const { searchDraft } = useOrdersRecognitionContext();
//     const queryString = (searchDraft ?? '').trim();
//     const debouncedValue = useDebouncedValue(queryString, 1000);
//     // const queryString = (state ?? '').trim();
//     const enabled = debouncedValue.length > 0;
//
//     return useQuery({
//         ...ordersRecognitionApi.getOrdersRecognitionSearchQueryOptions({
//             queryString: debouncedValue,
//         }),
//         enabled,
//     });
// };
export const useSearchOrders = () => {
    const { searchApplied } = useOrdersRecognitionContext();

    const enabled = searchApplied.length > 0;

    const query = useQuery({
        ...ordersRecognitionApi.getOrdersRecognitionSearchQueryOptions({
            queryString: searchApplied,
        }),
        enabled,
    });

    return { ...query, appliedQuery: searchApplied };
};
